import(/* webpackMode: "eager" */ "/opt/build/repo/apps/app/app/global-error.tsx");
